export const RETRY_PAYMENT_METHOD = 'RETRY_PAYMENT_METHOD';
export const generateRetryPaymentMethodFocusKey = (index: number) =>
  `${RETRY_PAYMENT_METHOD}_${index}`;
export const RETRY_PAYMENT_METHOD_FIRST = generateRetryPaymentMethodFocusKey(0);
export const RETRY_PAYMENT_METHOD_NEW = `${RETRY_PAYMENT_METHOD}_NEW`;

export const RETRY_PAYMENT_MODAL_OK = 'RETRY_PAYMENT_MODAL_OK';
export const RETRY_PAYMENT_MODAL_CANCEL = 'RETRY_PAYMENT_MODAL_CANCEL';
